import { render, staticRenderFns } from "./StepContent_kycQuestionnaire.vue?vue&type=template&id=5929e25b&"
import script from "./StepContent_kycQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./StepContent_kycQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports